<template>
  <div>
    <div v-if="!questionAnswered">
      <div class="mt-6 px-8 py-5 text-left">
        <session-logo :session="session"></session-logo>

        <!-- <p class="text-sm mb-2">Frage {{ questionOrder }} von 5</p> -->
        <h1 class="text-lg font-extralight">
          {{ generatedQuestion }}
        </h1>
        <p v-if="question.sub_question" class="mt-3 text-sm font-extralight">
          {{ question.sub_question }}
        </p>

        <div class="border-t border-gray-400 mt-4"></div>
      </div>

      <form @submit.prevent="submit" novalidate class="mt-8 px-4">
        <div class="flex items-center justify-center">
          <div class="w-fit">
            <div class="flex items-center justify-center space-x-1">
              <button type="button" :disabled="sending" v-for="num in [1, 2, 3, 4, 5, 6, 7, 8, 9, 10]" :key="num"
                @click="select(num)" class="
                  flex
                  items-center
                  justify-center
                  shrink-0
                  w-7
                  h-7
                  rounded-full
                  border border-transparent
                  
                  
                  focus:outline-none
                  focus:ring-2
                  focus:ring-markencode-blue
                  focus:ring-offset-2
                  text-md
                  
                " :class="[
                  form.answer == num
                    ? 'bg-markencode-blue text-white'
                    : 'bg-gray-300 text-gray-500',
                  sending ? '' : 'hover:bg-markencode-blue hover:text-white',
                ]">
                {{ num }}
              </button>
            </div>

            <div v-if="question.prio == 2" class="mt-4 flex items-center justify-between">
              <div>Doch</div>
              <div>Stimmt</div>
            </div>

            <div v-if="question.prio != 2" class="mt-4 flex items-center justify-between">
              <div>Nein</div>
              <div>Ja</div>
            </div>
          </div>
        </div>


        <submit-button :sending="sending" :validated="validated" class="max-w-4xl ml-auto mr-auto mt-16">{{
          translations.save }}</submit-button>
      </form>
    </div>



    <div v-if="questionAnswered" class="mt-6 px-8 py-5 text-center mx-auto">
      <h1 class="text-3xl font-extralight mb-13">
        {{ translations.thank_you }}
      </h1>

      <!-- <div class="border-t border-gray-400 mt-8 mb-8"></div> -->

      <a :href="route('diy-workshops.phase', {
        uuid: participant.uuid,
      })
        "
        class="block mx-auto mt-12 w-min rounded-md border border-transparent px-2 py-3 bg-brandpreneurship-dark-gray  font-medium text-white shadow-sm hover:bg-black focus:outline-none focus:border-black focus:shadow-outline-red transition ease-in-out duration-150 text-sm leading-5 z-50">WEITER</a>
    </div>

  </div>
</template>

<script>
import SubmitButton from '@/Shared/SubmitButton';
import { throttle } from 'lodash';
import SessionLogo from '@/Pages/DiyWorkshop/Shared/SessionLogo';

export default {
  components: {
    SubmitButton,
    SessionLogo,
  },

  props: {
    translations: {},
    participant: {
      required: true,
    },
    question: {
      required: true,
    },
    session: {
      required: true,
      type: Object,
    },
    answerParameters: {},
  },

  data() {
    return {
      sending: false,
      answered: false,
      form: {
        answer: '',
      },
    };
  },

  methods: {
    select(num) {
      this.form.answer = num;
    },

    submit() {
      this.sending = true;

      window.axios
        .post(
          this.route('diy-workshops.questions.store', {
            uuid: this.participant.uuid,
            questionId: this.question.id,
          }),
          this.form
        )
        .then(() => {
          this.sending = false;
          // this is an easy way to change the workflow:
          // now after clicking on "save" the user autimatically 
          // lands on the next question
          window.location.reload();
          // this.answered = true;
        })
        .catch((error) => {
          this.sending = false;
        });
    },
  },

  computed: {
    generatedQuestion() {

      if (!this.question?.brandname && !this.session.brandname && this.question?.question_default) {
        return this.question?.question_default;
      }

      if (this.question?.is_placeholder_question && (this.question?.brandname || this.session.brandname)) {
        return this.question.question.replace('%BRANDNAME', this.question?.brandname || this.session.brandname);
      }

      return this.question.question;
    },

    validated() {
      return this.form.answer > 0;
    },
    questionAnswered() {
      return this.answerParameters || this.answered;
    },
    // channel() {
    //   return Echo.channel(
    //     'markencode-app.session.' + this.participant.markencode_session.id
    //   );
    // },


  },


};
</script>